import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withDirectives as _withDirectives, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"min-height":"50vh"}
}
const _hoisted_2 = {
  key: 0,
  class: "absolute-top-left header__fix"
}
const _hoisted_3 = { class: "column q-gutter-y-md absolute-center text-center full-width text-grey-7" }
const _hoisted_4 = { class: "q-mt-lg" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "header__fix" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "container q-my-lg"
}
const _hoisted_9 = { class: "flex justify-end q-gutter-md no-wrap" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "header__fix absolute-top-left container q-py-md",
  style: {"z-index":"10"}
}
const _hoisted_12 = { class: "flex justify-between items-center" }
const _hoisted_13 = { class: "q-pt-md" }
const _hoisted_14 = { class: "container q-pt-lg q-pb-xl" }
const _hoisted_15 = { class: "row q-col-gutter-lg" }
const _hoisted_16 = { class: "col-12 col-sm-7" }
const _hoisted_17 = { class: "row q-col-gutter-y-lg" }
const _hoisted_18 = { class: "row q-gutter-y-lg full-width" }
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = {
  key: 0,
  class: "text-muted q-mb-md"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "text-h3 q-mt-none q-mb-sm" }
const _hoisted_23 = { class: "flex c-dot-list" }
const _hoisted_24 = {
  key: 0,
  class: "text-bold"
}
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { class: "flex no-wrap items-center q-gutter-md" }
const _hoisted_27 = { class: "text-muted text-xsmall" }
const _hoisted_28 = { class: "col-12 q-mb-md" }
const _hoisted_29 = {
  key: 0,
  class: "col-12"
}
const _hoisted_30 = { class: "q-mt-md text-small text-grey-7" }
const _hoisted_31 = { class: "text-small" }
const _hoisted_32 = ["href"]
const _hoisted_33 = { class: "col-12 col-sm-5" }
const _hoisted_34 = { class: "flex column no-wrap q-gutter-y-md full-height" }
const _hoisted_35 = { class: "price-box--wrapper sticky-price" }
const _hoisted_36 = { class: "flex column full-width no-wrap q-gutter-y-sm" }
const _hoisted_37 = {
  key: 0,
  class: "text-grey-8 text-h2"
}
const _hoisted_38 = {
  key: 0,
  class: "text-caption"
}
const _hoisted_39 = {
  key: 0,
  class: "font-inter-bold q-mt-md",
  style: {"font-size":"2rem","line-height":"2rem"}
}
const _hoisted_40 = {
  key: 1,
  class: "text-grey-8 text-h4"
}
const _hoisted_41 = { class: "text-caption" }
const _hoisted_42 = {
  key: 0,
  class: "q-pt-md"
}
const _hoisted_43 = ["href"]
const _hoisted_44 = { class: "flex q-gutter-md" }
const _hoisted_45 = { class: "col-grow" }
const _hoisted_46 = { class: "col-grow" }

import {computed, onMounted, onUnmounted, ref, watch} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {getCityFromNominatim, truncate} from 'src/etc/utils';
import Filter from 'src/etc/qutils/filter';
import BookmarkBtn from 'src/apps/core/components/BookmarkBtn.vue';
import DetailHeaderGallery from 'src/apps/adverts/components/DetailHeaderGallery.vue';
import FlagIcon from 'src/apps/core/components/FlagIcon.vue';
import FadeOutText from 'components/qutils/FadeOutText.vue';
import MessageUserButton from 'components/adverts/MessageUserButton.vue';
import AdvertLocationMap from 'src/apps/adverts/components/AdvertLocationMap.vue';
import GalleryModal from 'components/qutils/GalleryModal.vue';
import {useMeta, useQuasar} from 'quasar';
import vOnEleLoad from 'src/directive/onEleLoad';
import FixedAdvertDetailFooterBar from 'src/apps/adverts/components/FixedAdvertDetailFooterBar.vue';
import ItemDetailAttributes from 'src/apps/market/components/ItemDetailAttributes.vue';
import {shareItem} from 'src/apps/adverts/helper';
import {Item} from 'src/models/market';
import Market from 'src/api/market';
import {useMainStore} from 'stores/main';
import {showLoginDialog} from 'src/etc/helper';
import {useTracking} from 'src/etc/tracking';
import {useSearchStore} from 'src/apps/search/store';
import MarketDetailCrossSellingProducts from 'src/apps/market/components/MarketDetailCrossSellingProducts.vue';
import {askUserForRating} from 'src/apps/core/utils';



import {useMarketStore} from 'src/apps/market/store';

const __default__ = {
  preFetch({
             store,
             currentRoute,
             // previousRoute,
             // ssrContext,
             redirect,
             urlPath,
             // publicPath,
           }) {
    const marketStore = useMarketStore(store);
    const uuid = currentRoute.params.uuid.toString();
    return marketStore.fetchItem(uuid).catch((err) => {
      if (!err?.response) return err
      const {response} = err;

      if (response?.data?.code == 'item_not_active') {
        marketStore.items[uuid] = {status: 'inactive'}
        return
      }

      if ([404, 400].includes(response?.status)) {
        redirect({name: '404', query: {url: urlPath}});
        return err
      }

      console.error(err)
      redirect({name: 'error', query: {url: urlPath}})
      return err
    })
  }
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ItemDetailPage',
  setup(__props) {

const $route = useRoute()
const $router = useRouter()
const marketStore = useMarketStore()
const searchStore = useSearchStore()
const loading = ref(false)
const $q = useQuasar()
const mainStore = useMainStore()

const uuid = Array.isArray($route.params.uuid)
  ? $route.params.uuid[0]
  : $route.params.uuid;


const item = computed(() => {
  return marketStore.items[uuid]
})

const hasHistory = computed(() => {
  return window && window.history?.length > 0 && window.history.state?.back !== null
})


const itemImages = computed(() => {
  if (!item.value.images?.length) return []
  return item.value.images.flatMap(
    (obj) => obj.image_thumbnail_detail
  )
})

const parsedImages = computed(() => {
  if (!item.value.images) {
    return [];
  }
  return item.value.images.flatMap((obj) => {
    return {
      file: obj.image.path,
      thumb: obj.image_thumbnail?.path,
    };
  });
});

const dateJoined = computed(() => {
  let d = userOrBusiness.value?.date_joined || userOrBusiness.value?.created_at
  if (!d) return
  return new Date(d).toLocaleDateString('de', {
    month: 'short',
    year: 'numeric'
  })
})


function openGallery(position: number) {
  $q.dialog({
    component: GalleryModal,
    componentProps: {
      images: parsedImages.value,
      position: position,
    }
  })
}


/***
 * Price Box
 ***/
const showFixedBar = ref(true)
const priceBox = ref<HTMLElement | null>(null)
let observer, observerFixedFooter


const checkVisibilityFixedFooter = (entries) => {
  entries.forEach(entry => {
    if (!priceBox.value) {
      console.warn('priceBox value not defined')
      return
    }
    const priceBoxBottomDistanceToTop = priceBox.value?.getBoundingClientRect().top

    showFixedBar.value = !entry.isIntersecting && (priceBoxBottomDistanceToTop > 0 || window.scrollY === 0);
  })
}


watch(
  () => priceBox.value,
  () => {
    if (priceBox.value && observerFixedFooter) {
      observerFixedFooter.observe(priceBox.value);
    }
  }
)


const priceBoxOnLoad = (ele: HTMLElement) => {
  if (observer) {
    observer.observe(ele)
  }
}

const formattedPrice = computed(() => {
  if (!item.value?.price) return
  return Filter.currency({
    value: item.value.price,
    maximumFractionDigits: 0,
  })
})


const loadingShare = ref(false)


function share() {
  loadingShare.value = true
  shareItem($q, item.value).finally(() => {
    loadingShare.value = false
  })
}


const toProfile = computed(() => {
  if (item.value.by_business?.is_business && 'slug' in item.value.by_business) {
    return {name: 'business-profile', params: {slug: item.value.by_business?.slug}}
  }
  return {name: 'profile', params: {uuid: item.value?.by_user?.uuid}}
})


const lastUpdated = computed(() => {
  if (!item.value?.updated_at) return
  return Filter.i18nDateTime(item.value.updated_at)
})

const userOrBusiness = computed(() => {
  return item.value.by_business ?? item.value.by_user
})

onMounted(() => {
  observerFixedFooter = new IntersectionObserver(checkVisibilityFixedFooter, {
    root: null,
    threshold: [0.7, 1]
  });

  // check for rating
  askUserForRating($q, mainStore)
})

onUnmounted(() => {
  if (observer) {
    observer.disconnect()
  }

  if (observerFixedFooter) {
    observerFixedFooter.disconnect()
  }
})

function setStatus(status) {
  loading.value = true
  Market.changeItemStatus(uuid, status).then(() => {
    item.value.status = status
  }).finally(() => {
    loading.value = false
  })

}

const getJsonLd = function (item: Item) {
  if (!item) return {};

  const images = item.images?.flatMap((obj) => obj.image.path);

  return {
    product: {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name: `${item.title}`.trim(),
        image: images?.length ? images[0] : undefined,
        description: `${item.description_clean || ''}`,
        offers: {
          '@type': item.item_type === 'offer' ? 'Offer' : 'Demand',
          price: item.price || 0,
          priceCurrency: 'EUR',
          itemCondition: item.condition === 'new' ? 'https://schema.org/NewCondition' : 'https://schema.org/UsedCondition',
          availability: 'InStock',
          url: item.seo_link || $router.resolve({
            name: 'item-detail',
            params: {slug: item.seo_slug, uuid: item.uuid},
          }).fullPath,
          seller: {
            '@type': 'Person',
            name: item.by_user?.public_name || ''
          }
        }
      }),
    }
  }
}

const clickedShowPhone = ref(false)

function showPhone() {
  if (!mainStore.isLoggedIn) {
    showLoginDialog()
    return
  }
  const tracker = useTracking()
  tracker.trackInteractionPhone('item')
  clickedShowPhone.value = true;
}


function goToCat(category) {
  $router.push({name: 'search', query: {t: 'market'}}).then(() => {
    searchStore.updateFilterData({categories: category.id})
  })
}


const setMeta = function () {
  const item: Item = marketStore.items[uuid];

  if (!item || item?.status !== 'active') return;

  useMeta(() => {
    return {
      titleTemplate(title) {
        return `${item.seo_title} | ${title}`;
      },

      // link: [{rel: 'canonical', href: canonical}],
      script: getJsonLd(item),

      link: {
        canonical: {
          rel: 'canonical',
          href: $router.resolve({
            name: 'item-detail',
            params: {slug: item.seo_slug, uuid: item.uuid},
          }).fullPath,
        },
      },

      meta: {
        equiv: {
          'http-equiv': 'Content-Type',
          content: 'text/html; charset=UTF-8',
        },

        description: {
          name: 'description',
          template() {
            return `${truncate(item.description_clean, 147) || ''}`;
          },
        },
        ogType: {
          property: 'og:type',
          template() {
            return 'og:product';
          },
        },

        // note: for Open Graph type metadata you will need to use SSR, to ensure page is rendered by the server
        ogTitle: {
          property: 'og:title',

          // optional; similar to titleTemplate, but allows templating with other meta properties
          template() {
            return `${item.seo_title || ''}`;
          },
        },
        ogDescription: {
          property: 'og:description',
          template() {
            return `${item.description_clean || ''}`;
          },
        },

        ogUrl: {
          property: 'og:url',
          template() {
            return `${item.seo_link}`;
          },
        },

        ogImage: {
          property: 'og:image',
          template() {
            return `${item.cover_image_og?.image.path}`;
          },
        },

        ogImageUrl: {
          property: 'og:image:url',
          template() {
            return `${item.cover_image_og?.image.path}`;
          },
        },

        ogImageWidth: {
          property: 'og:image:width',
          template() {
            return '1200';
          },
        },

        ogImageType: {
          property: 'og:image:type',
          template() {
            return 'image/jpeg';
          },
        },

        ogRich_attachment: {
          property: 'og:rich_attachment',
          template() {
            return true;
          },
        },

        ogImageAlt: {
          property: 'og:image:alt',
          template() {
            return `${item.seo_title || ''}`;
          },
        },

        ogImageHeight: {
          property: 'og:image:height',
          template() {
            return '620';
          },
        },

        twitterImage: {
          property: 'twitter:image',
          template() {
            return `${item.cover_image_og?.image.path}`;
          },
        },
        twitterCard: {
          property: 'twitter:card',
          template() {
            return 'summary_large_image';
          },
        },
        twitterSite: {
          property: 'twitter:site',
          template() {
            return '@CamperTrader_de';
          },
        },
        twitterCreator: {
          property: 'twitter:creator',
          template() {
            return '@CamperTrader_de';
          },
        },
        twitterTitle: {
          property: 'twitter:title',
          template() {
            return `${item.seo_title || ''}`;
          },
        },
        twitterDescription: {
          property: 'twitter:description',
          template() {
            return `${item.description_clean || ''}`;
          },
        },
      },
    } as object;
  });
};
setMeta()



return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_no_ssr = _resolveComponent("q-no-ssr")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, null, {
    default: _withCtx(() => [
      (item.value?.status === 'inactive' && !item.value.is_owner)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            (_unref($q).screen.lt.sm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_q_btn, {
                    class: "q-my-md",
                    flat: "",
                    icon: "fas fa-arrow-left",
                    round: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (hasHistory.value ? _unref($router).go(-1) : _unref($router).push({name: 'search'})))
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createVNode(_component_q_icon, {
                  name: "fas fa-exclamation-circle",
                  size: "3rem"
                })
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-h3" }, "Diese Anzeige ist leider nicht mehr aktiv.", -1)),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_q_btn, {
                  to: { name: 'search', query: {t: 'market'} },
                  color: "primary",
                  rounded: "",
                  unelevated: "",
                  "no-caps": ""
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Weitere anzeigen ")
                  ])),
                  _: 1,
                  __: [4]
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!loading.value && item.value && (item.value.status === 'active' || item.value.is_owner))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (item.value.status === 'inactive')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_q_banner, { class: "bg-warning text-white q-py-xl" }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createElementVNode("div", { class: "container text-h4 text-center" }, " Dieses Inserat ist derzeit inaktiv ", -1)
                      ])),
                      _: 1,
                      __: [6]
                    })
                  ]))
                : _createCommentVNode("", true),
              (['active', 'inactive'].includes(item.value.status) && item.value.is_owner)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_q_btn, {
                        color: "grey-9",
                        "no-caps": "",
                        outline: "",
                        unelevated: "",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (setStatus(item.value.status === 'active' ? 'inactive' : 'active')))
                      }, {
                        default: _withCtx(() => [
                          (item.value.status === 'active')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("Anzeige deaktivieren")
                              ], 64))
                            : (item.value.status === 'inactive')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Anzeige aktivieren"))
                              : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_btn, {
                        color: "primary",
                        "no-caps": "",
                        outline: "",
                        unelevated: "",
                        to: {name: 'update-item', params: {uuid: item.value.uuid}}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: "fas fa-pencil",
                            size: "xs"
                          }),
                          _cache[7] || (_cache[7] = _createTextVNode("  Anzeige bearbeiten "))
                        ]),
                        _: 1,
                        __: [7]
                      }, 8, ["to"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("section", {
              class: _normalizeClass([{ container: !_unref($q).screen.lt.sm }, "relative-position"])
            }, [
              (_unref($q).screen.lt.sm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_q_btn, {
                          round: "",
                          color: "white",
                          "text-color": "dark",
                          size: "0.65rem",
                          icon: "fas fa-angle-left",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (hasHistory.value ? _unref($router).go(-1) : _unref($router).push({name: 'search'})))
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(BookmarkBtn, {
                          obj: item.value,
                          type: "item"
                        }, null, 8, ["obj"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(DetailHeaderGallery, {
                images: itemImages.value,
                "aspect-ratio": 3/4,
                "gallery-type": "item",
                onOpenGallery: _cache[3] || (_cache[3] = val => openGallery(val))
              }, null, 8, ["images"])
            ], 2),
            _createElementVNode("section", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        (item.value.categories.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value.categories[0].ancestor_path, (ancestor, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: ancestor.id
                                }, [
                                  _createElementVNode("a", {
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => (goToCat(ancestor)), ["prevent"])
                                  }, _toDisplayString(ancestor.name), 9, _hoisted_21),
                                  (index + 1 < item.value.categories[0].ancestor_path.length)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" > ")
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("h1", _hoisted_22, _toDisplayString(item.value.title), 1),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_23, [
                            (item.value.address && _unref(getCityFromNominatim)(item.value.address))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createVNode(FlagIcon, {
                                    "country-code": item.value.address.country
                                  }, null, 8, ["country-code"]),
                                  _createTextVNode(" " + _toDisplayString(_unref(getCityFromNominatim)(item.value.address)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("section", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_router_link, { to: toProfile.value }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_avatar, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_img, {
                                      "no-spinner": "",
                                      src: userOrBusiness.value?.avatar?.path,
                                      alt: "Profile image",
                                      class: "bg-white"
                                    }, null, 8, ["src"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_router_link, {
                              class: "text-bold",
                              to: toProfile.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(userOrBusiness.value?.public_name || userOrBusiness.value?.name), 1)
                              ]),
                              _: 1
                            }, 8, ["to"]),
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("span", null, _toDisplayString(userOrBusiness.value?.is_business ? 'Händler' : 'Privatanbieter'), 1),
                              (dateJoined.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" • Seit " + _toDisplayString(dateJoined.value) + " dabei", 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]),
                      _createVNode(ItemDetailAttributes, {
                        class: "col-12",
                        "model-value": item.value
                      }, null, 8, ["model-value"]),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(FadeOutText, {
                          "max-height": 200,
                          "background-color": "white",
                          style: {"white-space":"pre-line"}
                        }, {
                          default: _withCtx(() => [
                            _cache[8] || (_cache[8] = _createElementVNode("div", null, [
                              _createElementVNode("span", { class: "text-bold" }, "Beschreibung")
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(item.value.description || 'Keine Beschreibung'), 1)
                          ]),
                          _: 1,
                          __: [8]
                        })
                      ])
                    ]),
                    _createVNode(MarketDetailCrossSellingProducts, {
                      item: item.value,
                      class: "col-12"
                    }, null, 8, ["item"]),
                    (item.value.lat_lng)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_29, [
                          _createVNode(AdvertLocationMap, {
                            "is-business": false,
                            lat: item.value.lat_lng[0],
                            lng: item.value.lat_lng[1]
                          }, null, 8, ["lat", "lng"]),
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_q_no_ssr, { tag: "div" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Letzte Änderung: " + _toDisplayString(lastUpdated.value), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("a", {
                                href: `mailto:report@campertrader.de?subject=Item Report ${item.value.uuid}`,
                                target: "_blank"
                              }, " Inserat melden ", 8, _hoisted_32)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("div", {
                        ref_key: "priceBox",
                        ref: priceBox,
                        class: "price-box rounded-borders q-pa-md q-card--bordered bg-white"
                      }, [
                        _createElementVNode("div", _hoisted_36, [
                          (item.value.offer_type === 'give_away')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, " Zu verschenken "))
                            : (item.value.item_type === 'request')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-grey-8 text-h2" }, " Gesuch ", -1)),
                                  _createElementVNode("div", null, [
                                    _createTextVNode(_toDisplayString(item.value.offer_type_display), 1),
                                    (item.value.price)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, " bis " + _toDisplayString(!item.value.price ? '- €' :
                              _ctx.$filters.currency({
                                value: item.value.price,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  (item.value.price)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(formattedPrice.value), 1))
                                    : _createCommentVNode("", true),
                                  (((item.value.price ?? undefined) === undefined && ['sale', 'rent'].includes(item.value.offer_type)) || item.value.is_negotiable)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, " Verhandlungsbasis "))
                                    : _createCommentVNode("", true)
                                ], 64)),
                          _createElementVNode("div", null, [
                            _createVNode(_component_q_icon, { name: "forward_to_inbox" }),
                            _cache[10] || (_cache[10] = _createTextVNode("  ")),
                            _createElementVNode("span", _hoisted_41, [
                              _createTextVNode(_toDisplayString(item.value.shipping_display) + " ", 1),
                              (item.value.price_shipping && ['shipping_possible', 'shipping_only'].includes(item.value.shipping))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" für " + _toDisplayString(_ctx.$filters.currency({
                              value: item.value.price_shipping,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createVNode(_component_q_separator, { class: "q-my-lg" }),
                        _createElementVNode("div", null, [
                          _createVNode(MessageUserButton, {
                            "item-uuid": item.value.uuid,
                            class: "rounded-borders full-width",
                            "show-modal": false,
                            label: "Nachricht senden",
                            big: "",
                            size: "1rem"
                          }, null, 8, ["item-uuid"])
                        ]),
                        (item.value.phone)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              _createVNode(_component_q_banner, { class: "bg-grey-3 text-center rounded-borders" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, { name: "fas fa-phone" }),
                                  (clickedShowPhone.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _cache[11] || (_cache[11] = _createTextVNode("   ")),
                                        _createElementVNode("a", {
                                          href: `tel:${item.value.phone}`,
                                          class: "text-h4"
                                        }, _toDisplayString(item.value.phone), 9, _hoisted_43)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _cache[12] || (_cache[12] = _createTextVNode("   ")),
                                        _createElementVNode("a", {
                                          href: "#",
                                          onClick: _withModifiers(showPhone, ["prevent"])
                                        }, " Telefonnummer anzeigen ")
                                      ], 64))
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_q_separator, { class: "q-my-md" }),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _createVNode(BookmarkBtn, {
                                "no-wrap": "",
                                color: "grey-8",
                                class: "full-width",
                                obj: item.value,
                                type: "item",
                                round: false
                              }, {
                                label: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.value.is_favorite ? 'Gemerkt' : 'Merken'), 1)
                                ]),
                                _: 1
                              }, 8, ["obj"])
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              _createVNode(_component_q_btn, {
                                "no-wrap": "",
                                class: "full-width",
                                outline: "",
                                color: "grey-8",
                                loading: loadingShare.value,
                                onClick: share
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "fas fa-share-alt",
                                    size: "xs"
                                  }),
                                  _cache[13] || (_cache[13] = _createTextVNode("  Teilen "))
                                ]),
                                _: 1,
                                __: [13]
                              }, 8, ["loading"])
                            ])
                          ])
                        ])
                      ], 512)
                    ])), [
                      [_unref(vOnEleLoad), priceBoxOnLoad]
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : (!item.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(" no item ")
            ], 64))
          : _createCommentVNode("", true),
      _createVNode(_Transition, {
        "leave-active-class": "animated fadeOutDown",
        "enter-active-class": "animated fadeInUp"
      }, {
        default: _withCtx(() => [
          (item.value?.status === 'active' && _unref($q).screen.lt.sm && showFixedBar.value)
            ? (_openBlock(), _createBlock(FixedAdvertDetailFooterBar, {
                key: 0,
                "can-click-phone": _unref(mainStore).isLoggedIn,
                class: "footer__fix",
                item: item.value,
                "phone-number": item.value?.phone
              }, null, 8, ["can-click-phone", "item", "phone-number"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})